import React, { Component } from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

const AccordionWrapper = styled.div`
  margin-bottom: 15px;
  padding: 25px;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.15);
`;

const AccordionHeading = styled.h4`
  user-select: none;  
  &:hover {
    cursor: pointer;
  };
`;
const AccordionDesc = styled.div`
  p {
    margin-top: 25px !important;
    margin-bottom: 0 !important;
  }
  a {
    color: #2222ca;
  }
`;
  
export class Accordion extends Component {
  state = {
    open: false
  }

  handleClick = () => {
    this.setState({
      open: this.state.open ? false : true
    })
  }

  render() {
    return (
      <AccordionWrapper>
        <AccordionHeading onClick={this.handleClick}>{this.props.title}</AccordionHeading>
        { this.state.open ? (
          <AccordionDesc>{this.props.prismicHTML ? RichText.render(this.props.description) : this.props.description}</AccordionDesc>
        ) : null }
      </AccordionWrapper>
    );
  }
}